module.exports = __webpack_public_path__ + "static/media/check.b345f254.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/check.svg
// module id = 12
// module chunks = 1